import config from '../../config';

const statusProgressMax = Math.max(
  ...Object.values(config.statusProgressAmount)
);

export default function SystemProgressBar({ status }) {
  status = status || { Status: '' };
  let progressLookupString =
    status['Status'] + '|' + (status['Detailed Status'] || '');
  let progressAmount = config.statusProgressAmount[progressLookupString] || 0;
  let progressPercent = progressAmount / statusProgressMax;

  let progressLabelString = status['Status'];
  if (status['Detailed Status']) {
    progressLabelString += ' - ' + status['Detailed Status'];
  }

  return (
    <div
      className={
        'system-progress-bar' +
        (progressAmount === 0 ? ' nonspecific' : '') +
        (progressAmount > 11 ? ' flipped' : '')
      }
    >
      <div
        className='bar-fill'
        style={
          progressAmount === 0 ? {} : { width: progressPercent * 100 + '%' }
        }
      >
        <div className='progress-label'>{progressLabelString}</div>
      </div>
    </div>
  );
}
